import { Component, ViewChild, ElementRef, AfterViewInit, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { ApiService } from '../../api/api.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-cbtfeepay',
  templateUrl: './cbtfeepay.component.html',
  styleUrls: ['./cbtfeepay.component.css']
})
export class CbtfeepayComponent implements OnInit {

  @ViewChild('uploadPhotoInput', { static: false }) uploadPhotoInput!: ElementRef;


  form1: boolean = true;
  public bool_pri_result: boolean = false;

  bdnuForm: any;
  nimiForm: any;
  submitted = false;



  public numberStud: any;

  public niminumberStud: any;


  public state: any;
  public district: any;
  public iticode: any;
  public trade: any;


  public pri_genrateid: any;
  public ccrefnoStatus: any;
  public var_placeholder = " Enter Order ID P16_PU09001617-1617099122"
  public enter_date: any;

  onChangeState(data: any) {
    //console.log(data.target.value);
    this.bdnuForm.get('district').reset();
    this.bdnuForm.get('iticode').reset();
    // this.bdnuForm.get('trade').reset();

    var myargs = {
      stateName: data.target.value
    }
    this.api.enterState(myargs).subscribe((result: any) => {
      //console.log(JSON.stringify(result));
      this.district = result;
    });
  }


  onChangeDistrict(data: any) {
    this.bdnuForm.get('iticode').reset();
    // this.bdnuForm.get('trade').reset();
    var myargs = {
      districtName: data.target.value
    }
    this.api.enterIticode(myargs).subscribe((result: any) => {
      console.log(JSON.stringify(result));
      this.iticode = result;

      this.bool_iti_select = true;
      this.bool_iti_text = false;

    });
  }
  onChangeIticode(data: any) {
    var myargs = {
      iticodeName: data.target.value
    }
    this.api.enterTrade(myargs).subscribe((result: any) => {
      if (result.status == 'fail') {
        this.bdnuForm.get('trade').reset();
        return;
      }
      else {
        this.trade = result;
      }


    });
  }

  tradeChange(data: any) {

    //console.log(data.target.value);
    var myargs = {
      tradeName: data.target.value
    };



  }





  public readioSelected: any;
  public bulk_bool = false;
  public single_bool = false;
  public bool_bdnuForm = true;
  public bool_nimiForm = false;

  showContent(event: any) {

  
    //this.formArr.removeAt(0);
    this.bdnuForm.controls['ccrefno'].reset();

    if (event == 'radio1') {
      // this.bulk_bool = true;
      // this.single_bool = false;
      // this.bool_nimiForm = false;
      // this.bool_bdnuForm = true;
      this.bdnuForm.controls['ccrefnostatus'].reset();
      //this.bdnuForm.reset();
      this.nimiForm.reset();
      
      
      this.bdnuForm.get('singlerollno').clearValidators();
      this.bdnuForm.get('singlerollno').value = '';
      this.bdnuForm.get('singlerollno').updateValueAndValidity();
      this.bdnuForm.get('numberofstud').setValidators([Validators.required]);
      this.bdnuForm.get('niminumberofstud').setValidators([Validators.required]);
      this.bdnuForm.get('bulkrollno').setValidators([Validators.required]);
      this.bdnuForm.get('amount').setValidators([Validators.required]);
      this.bdnuForm.get('state').setValidators([Validators.required]);
      this.bdnuForm.get('district').setValidators([Validators.required]);
      // this.bdnuForm.get('iticode').setValidators([Validators.required]);
      this.var_placeholder = 'Enter Order ID P16_PU09001617-1617099122';
    }
    else if(event == 'radio3'){
      // this.bool_bdnuForm = false;
      // this.bool_nimiForm = true;
      //this.bdnuForm.controls['ccrefnostatus'].reset();
      //this.bdnuForm.reset();
     // this.nimiForm.reset();
    } else {
      //this.bdnuForm.reset();
      //this.nimiForm.reset();

      // this.bulk_bool = false;
      // this.single_bool = true;

      // this.bool_nimiForm = false;
      // this.bool_bdnuForm = true;
      this.bdnuForm.controls['ccrefnostatus'].reset();
      this.bdnuForm.get('numberofstud').clearValidators();
      this.bdnuForm.get('numberofstud').clearValidators();
      this.bdnuForm.get('numberofstud').value = '';
      this.bdnuForm.get('numberofstud').updateValueAndValidity();

      this.bdnuForm.get('niminumberofstud').clearValidators();
      this.bdnuForm.get('niminumberofstud').clearValidators();
      this.bdnuForm.get('niminumberofstud').value = '';
      this.bdnuForm.get('niminumberofstud').updateValueAndValidity();

      this.bdnuForm.get('amount').clearValidators();
      this.bdnuForm.get('amount').value = '';
      this.bdnuForm.get('amount').updateValueAndValidity();
      this.bdnuForm.get('bulkrollno').clearValidators();
      this.bdnuForm.get('bulkrollno').value = '';
      this.bdnuForm.get('bulkrollno').updateValueAndValidity();
      this.bdnuForm.get('state').clearValidators();
      this.bdnuForm.get('state').value = '';
      this.bdnuForm.get('state').updateValueAndValidity();
      this.bdnuForm.get('district').clearValidators();
      this.bdnuForm.get('district').value = '';
      this.bdnuForm.get('district').updateValueAndValidity();
      // this.bdnuForm.get('iticode').clearValidators();
      this.bdnuForm.get('iticode').value = '';
      this.bdnuForm.get('iticode').updateValueAndValidity();
      this.bdnuForm.get('singlerollno').setValidators( [Validators.required, Validators.pattern('^19|18[0-9]{10}$')]); 
      this.var_placeholder = 'Enter Order ID 180810038311';
      this.nimitest(0);


    }

  }

  //convenience getter for easy access to form fields
  get f() {
    return this.bdnuForm.controls;
  }

  get n() {
    return this.nimiForm.controls;
  }


  onSubmit() {
    //alert(d.getDate() + "/" + month + "/" + d.getFullYear())
    //alert("test: " + this.ccrefnoStatus)
    this.submitted = true;

    // stop here if form is invalid
    if (this.bdnuForm.invalid) {
      return;
    }


    this.api
      .insertbdnuForm(this.bdnuForm.value)
      .subscribe((result: any) => {
        console.log("bdnu: " + JSON.stringify(result));
        this.pri_genrateid = result.refid;
        this.form1 = false;
        this.bool_pri_result = true;
        window.scroll(0, 0);

      });
  }

  onFileSelectPhoto(event: any){
    const file = event.target.files[0];
    // this.fileInputLabel = file.name;
    console.log(file);
    if (100000 < file.size) {
      alert("Upload Only 100kb");
      this.uploadPhotoInput.nativeElement.value = "";
    }
    // this.fileArray = file;
    this.nimiForm.get('uploadedPhoto').setValue(file);
  }

  public bool_photo:boolean =false;
  pay_change(event:any){
    if(event.target.value == 'Cash Deposit'){
      this.bool_photo = true;

      this.nimiForm.get('ascmob').clearValidators();
      this.nimiForm.get('ascmob').value = '';
      this.nimiForm.get('ascmob').updateValueAndValidity();

      this.nimiForm.get('utr').clearValidators();
      this.nimiForm.get('utr').value = '';
      this.nimiForm.get('utr').updateValueAndValidity();

    }
    else{
      this.bool_photo =false;
      this.nimiForm.get('ascmob').setValidators([Validators.required]);
      this.nimiForm.get('utr').setValidators([Validators.required]);
    }
  }
  onnimiSubmit() {


    this.submitted = true;

    if (this.nimiForm.invalid) {
      return;
    }

if(this.nimiForm.controls['paymethod'].value == 'Cash Deposit' ){


  if (!this.nimiForm.get('uploadedPhoto').value) {
    alert(' Upload Cash Deposit file !');
    return;
  }

  const formData = new FormData();
  formData.append('uploadedPhoto', this.nimiForm.get('uploadedPhoto').value);
  formData.append('nimiForm', JSON.stringify(this.nimiForm.value));

  var myargs = formData;
  var myargsText = this.nimiForm.value;
  console.log(myargs)



  this.api
    .insertNIMIForm(myargs)
    .subscribe((result: any) => {
      console.log("bdnu: " + JSON.stringify(result));
      this.pri_genrateid = result.refid;
      this.form1 = false;
      this.bool_pri_result = true;
      window.scroll(0, 0);

    });


}
else{




  this.api.insertNIMIFormwithoutupload(this.nimiForm.value).subscribe((result: any) => {
      console.log("bdnu: " + JSON.stringify(result));
      this.pri_genrateid = result.refid;
      this.form1 = false;
      this.bool_pri_result = true;
      window.scroll(0, 0);

    });




}

  }



  constructor(private formBuilder: FormBuilder, private api: ApiService, private router: Router) { 

   }


  ngOnInit(): void {
    const d = new Date();
    var month = d.getMonth() + 1;

    this.enter_date = d.getDate() + "/" + month + "/" + d.getFullYear();


    this.api.liststatecbtfee().subscribe((data: any) => {
      this.state = data;
      console.log(this.state)
      //console.log(data);
    });

    // this.api.listIticode().subscribe((result: any) => {
    //   console.log(JSON.stringify(result));
    //   this.iticode = result;
    // });

    this.bdnuForm = this.formBuilder.group({
      radiobtn: ['', Validators.required],
      numberofstud: ['', Validators.required],
      amount: [''],
      singlerollno: ['', [Validators.required, Validators.pattern("^(19|18)[0-9]{10}$")]],
      state: ['', Validators.required],
      district: ['', Validators.required],
      iticode: [''],
      //trade: ['', Validators.required],
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      mobileno: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      ccrefno: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{12}$")]],
      ccrefnostatus: ['', Validators.required],
      orderid: ['', Validators.required],
      date: ['', Validators.required],
      descreption: ['', [Validators.maxLength(500)]],
      acceptTerms: [false, Validators.requiredTrue],
      qualification: this.formBuilder.array([]),
      enterDate: [this.enter_date],
      bulkrollno: [''],
    });

    this.nimiForm = this.formBuilder.group({
      state: ['', Validators.required ],
      name: ['', Validators.required ],
      email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      mobileno: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      // transno: ['', Validators.required],
      // orderid: [''],
      date: ['', Validators.required ],
      niminumberofstud: ['', Validators.required],
      paymethod: ['',  Validators.required],
      ascmob: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      utr: ['', Validators.required],
      radiobtn: ['', Validators.required ],
      bulkrollno: ['', ],
      amount: [''],
      descreption: ['', [Validators.maxLength(500)]],
      acceptTerms: [false, Validators.requiredTrue],
      nimiqualification: this.formBuilder.array([]),
      enterDate: [this.enter_date],
      uploadedPhoto: new FormControl(),
    });

  }

  newQuantity(): FormGroup {
    return this.formBuilder.group({
      //bukregno: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{12}$")]],
      bukregno: ['',  [Validators.required, Validators.pattern("^(19|18)[0-9]{10}$")]],
    })
  }


  get qualification(): FormArray {
   // console.log(this.bdnuForm.get("qualification") as FormArray)
    return this.bdnuForm.get("qualification") as FormArray
  }

  get qualificationFormGroups() { return this.qualification.controls as FormGroup[]; }


  addQualification() {
    this.qualification.push(this.newQuantity());
  }

  removeQualification(i: number) {

    this.qualification.removeAt(i);
  }


  ////////////


  niminewQuantity(): FormGroup {
    return this.formBuilder.group({
      nimibukregno: ['',  [Validators.required, Validators.pattern("^(19|18)[0-9]{10}$")]],
     // nimibukregno: ['',  [Validators.required, Validators.pattern('^19|18[0-9]{10}$')]],          
    })
  }


  get nimiqualification(): FormArray {
   // console.log(this.bdnuForm.get("qualification") as FormArray)
    return this.nimiForm.get("nimiqualification") as FormArray
  }

  get nimiqualificationFormGroups() { return this.nimiqualification.controls as FormGroup[]; }


  nimiaddQualification() {
    this.nimiqualification.push(this.niminewQuantity());
  }

  // nimiremoveQualification(i: number) {

  //   this.nimiqualification.removeAt(i);
  // }



  public date = new Date().getDate();
  public month = new Date().getMonth() + 1;
  public year = new Date().getFullYear();
  public currentDate = this.date + '-' + this.month + '-' + this.year;

  datePickerConfig = {
    format: 'DD-MM-YYYY',
    min: '01-12-2020',
    max: '31-03-2021'
    //max: this.currentDate,
  };

  datePickerConfigDir = {
    format: 'DD-MM-YYYY',
    
    //max: this.currentDate,
  };






  onReset() {
    this.submitted = false;
    this.bdnuForm.reset();
  }



  pri_again_fn() {
    window.scroll(0, 0);
    this.bool_pri_result = false;
    this.form1 = true
  }

  track_fn() {
    window.scroll(0, 0);
    this.router.navigateByUrl('/trackId')

  }

  totAmount: any;
  onKey(event: any) {
    console.log(event.target.value);

    this.qualification.clear()


    // for (var i = 0; i < event.target.value; i++) {
    //   this.qualification.push(this.newQuantity());
    // }

    this.totAmount = event.target.value * 376;
  }

  onnimiKey(event: any) {
    console.log(event.target.value);

    this.nimiqualification.clear()


    // for (var i = 0; i < event.target.value; i++) {
    //   this.qualification.push(this.newQuantity());
    // }

    this.totAmount = event.target.value * 376;
  }


  test(event: any) {
    console.log(event.target.value);

    for (var i = 0; i < event.target.value; i++) {
      this.qualification.push(this.newQuantity());
    }

    // this.totAmount = event.target.value * 376;
  }

  nimitest(event: any) {
    console.log(event.target.value);

    for (var i = 0; i < event.target.value; i++) {
      this.nimiqualification.push(this.niminewQuantity());
    }

    // this.totAmount = event.target.value * 376;
  }

  omit_number(event: any) {
    var k;
    k = event.charCode;
    return ((k >= 48 && k <= 57) || k == 32);
    // return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  omit_email(event: any) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || k == 45 || k == 46 || k == 64 || k == 95 || k == 32);
  }

  omit_text(event: any) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 32);
    // return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }
  omit_spl(event: any) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || k == 47 || k == 32);
    // return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  omit_all(event: any) {
    var k;
    k = event.charCode;
    return ((k >= 127 && k <= 0));
    // return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }


  cc_check(event: any) {

    var rdbtn_value = this.bdnuForm.controls['radiobtn'].value;
    if(rdbtn_value == 'radio2'){


      var value = event.target.value;
      var args = {
        ccref: value
      }

      this.api.ccrefStatus(value).subscribe((data: any) => {
        this.ccrefnoStatus = data.RefStatus;
        if(this.ccrefnoStatus == ''){
          //alert('empty')
          this.ccrefnoStatus = 'blank'
        }
        this.bdnuForm.controls.ccrefnostatus.setValue(this.ccrefnoStatus);

      });

      // this.api.ccCheck(args).subscribe((result: any) => {


      //   if (result[0]['count'] > 0) {
      //     alert("Already Enter this CC Refno ")
      //     this.bdnuForm.controls['ccrefno'].reset()

      //   }
      //   else {
      //     this.api.ccrefStatus(value).subscribe((data: any) => {
      //       this.ccrefnoStatus = data.RefStatus;
      //       if(this.ccrefnoStatus == ''){
      //         //alert('empty')
      //         this.ccrefnoStatus = 'blank'
      //       }
      //       this.bdnuForm.controls.ccrefnostatus.setValue(this.ccrefnoStatus);

      //     });
      //   }
      // });

    }
    else{

      var value = event.target.value;
      var args = {
        ccref: value
      }


          this.api.ccrefStatus(value).subscribe((data: any) => {
            this.ccrefnoStatus = data.RefStatus;
            if(this.ccrefnoStatus == ''){
              //alert('empty')
              this.ccrefnoStatus = 'blank'
            }
            this.bdnuForm.controls.ccrefnostatus.setValue(this.ccrefnoStatus);

          });


    }






  }

  public bool_iti_select: boolean = true;
  public bool_iti_text: boolean = false;

  entry_iti(event:any){
    if(event.target.value == 'Enter ITI Code'){
      // alert("test")
      this.bool_iti_select = false;
      this.bool_iti_text = true;

      this.bdnuForm.controls['iticode'].reset();
      return;
    }
  }


  utr_check(event:any){

    const args = {
      utr: event.target.value
    };

    this.api.utr_check(args).subscribe((data: any) => {

      if(data.count >= 1){
        alert('Already UTR / Transcation Number Registered');
        this.nimiForm.controls['utr'].reset()
      }

    });




  }

}
